import {getKeycloak} from '../api/interceptors';

export const userService = {

    hasRole: (expectedRole) => {
        const keycloak = getKeycloak();
        const roles = keycloak?.realmAccess?.roles || [];
        return Promise.resolve(roles.includes(expectedRole));
    }

};